import {
  isPastDate,
  isToday,
  useFormatDateWithDayAndMonth,
  useGetHourMinuteString,
  useTranslation,
} from '@aboutyou/i18n';
import {COLORS, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const InspirationGridSectionTeaserCaption: React.FC<{
  liveAt: Date;
}> = ({liveAt}) => {
  const {t} = useTranslation();
  const formatHourMinute = useGetHourMinuteString();
  const formatDate = useFormatDateWithDayAndMonth();
  const isStartTimeToday = isToday(liveAt);
  const isAlreadyStarted = isPastDate(liveAt);

  if (isAlreadyStarted) {
    return <Caption weight="w500">{t('Live now')}</Caption>;
  }

  if (isStartTimeToday) {
    const timeString = formatHourMinute(liveAt);

    return (
      <Caption weight="w500">
        {t('Today at {timeString}', {timeString})}
      </Caption>
    );
  }

  return <Caption weight="w500">{formatDate(liveAt)}</Caption>;
};

const Caption = styled(Text)`
  display: block;
  background-color: ${COLORS.LiveShopping};
  padding: 6px 8px;
  border-radius: 0 0 8px 8px;
  text-transform: uppercase;
  text-align: center;
`;
